<template>
  <div class="tagType">
    <el-table :data="tableList" class="tableList">
      <el-table-column
        align="center"
        prop="labelTypeId"
        label="标签ID"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="labelTypeName"
        label="标签类型"
      ></el-table-column>
      <el-table-column
        prop="remark"
        show-overflow-tooltip
        label="备注"
      ></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div class="btnGroup">
            <span class="table__list__btn" @click="editDialog(scope.row)"   v-show="menusList.indexOf('LABEL_MANAGE_MODIFY')!='-1'">
              编辑
            </span>
            <span class="table__list__btn" @click="onDelete(scope.row)"  v-show="menusList.indexOf('LABEL_MANAGE_DELETE')!='-1'">
              删除
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="`${action == 'add' ? '新增' : '编辑'}标签类型`"
      width="30%"
      :visible.sync="dialog"
      class="onDialog"
      :close-on-click-modal="false"
      :top="'20vh'"
    >
      <el-form
        label-width="90px"
        class="onDialog__form"
        :rules="rules"
        ref="form"
        :model="data"
      >
        <el-form-item label="标签类型" prop="labelTypeName">
          <el-input v-model="data.labelTypeName" size="large"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="data.remark"
            size="large"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
        <el-button @click="dialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "tagType",
  data() {
    return {
      id: null,
      action: "",
      dialog: false,
      tableList: [],
      menusList: [],
      data: {
        labelTypeName: "",
        remark: "",
      },
      rules: {
        labelTypeName: {
          required: true,
          message: "请输入标签类型名称",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    addDialog() {
      this.action = "add";
      this.data.labelTypeName = "";
      this.data.remark = "";
      this.dialog = true;
    },
    confirm(form) {
      this.$refs[form].validate((va) => {
        if (va) {
          if (this.action == "add") {
            Axios.ajax({
              url: "/labelType/add",
              method: "post",
              data: {
                labelTypeName: this.data.labelTypeName,
                remark: this.data.remark,
              },
            }).then((res) => {
              this.dialog = false;
              this.queryTableList();
              if (res.resultCode == 0) {
                this.$message.success("编辑成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          } else {
            Axios.ajax({
              url: "/labelType/edit",
              method: "post",
              data: {
                labelTypeId: this.id,
                labelTypeName: this.data.labelTypeName,
                remark: this.data.remark,
              },
            }).then((res) => {
              this.dialog = false;
              this.queryTableList();
              if (res.resultCode == 0) {
                this.$message.success("新增成功！");
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          }
        }
      });
    },
    editDialog(row) {
      this.dialog = true;
      this.id = row.labelTypeId;
      this.action = "edit";
      this.data.labelTypeName = row.labelTypeName;
      this.data.remark = row.remark;
    },
    onDelete(row) {
      Axios.ajax({
        url: "/labelType/delete",
        method: "post",
        data: {
          labelTypeId: row.labelTypeId,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.$message.success("删除成功！");
        } else {
          this.$message.warning(res.resultMessage);
        }
        this.queryTableList();
      });
    },
    queryTableList() {
      Axios.ajax({
        url: "/labelType/list",
        method: "get",
      }).then(({ data }) => {
        this.tableList = data;
      });
    },
  },
  mounted() {
    this.menusList=Vue.prototype.menusList

  },
  created() {
    this.queryTableList();
  },
};
</script>

<style lang="less" scoped>
.tagType {
  height: 67.5vh;
  overflow: auto;
  .btnGroup {
    cursor: pointer;
    color: #2a62ff;
    font-weight: normal;
    .table__list__btn {
      margin: 0 5px;
    }
  }
}
.onDialog {
  &__form {
    padding: 0 30px;
  }
}
</style>
<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
